import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-base-client',
  template: 'NONE'
})
export class BaseClientComponent implements OnDestroy {

  protected subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    // Add this to release subscriptions ???
    this.subscriptions = [];
  }
}
